module.exports = __webpack_public_path__ + "static/media/natural_language.e9e43a24.svg";